/* istanbul ignore file */
export const ENTER = 'Enter';
export const ARROW_DOWN = 'ArrowDown';
export const ARROW_UP = 'ArrowUp';
export const SPACE = ' ';
export const HOME = 'Home';
export const END = 'End';
